import React from 'react';
import { number } from 'prop-types';

export const ChipsShadow = props => {
  const length = props.length ? props.length : 5;
  const chips = [];

  for (let i = 0; i < length; i++) {
    chips.push(<div className="m-shadow-chip" key={i}></div>);
  }

  return <div>{chips}</div>;
};

ChipsShadow.propTypes = {
  length: number,
};
ChipsShadow.defaultProps = {
  length: 5,
};
